export default __webpack_public_path__ + "static/media/Moojan_Asghari_AHV_In_Moms_We_Trust.022404b2.jpg";